// extracted by mini-css-extract-plugin
export var active = "_so-1";
export var circle = "_so-0";
export var completed = "_so-2";
export var connector = "_so-4";
export var connectorCompleted = "_so-7";
export var connectorSpacer = "_so-5";
export var iconStrokeOverride = "_so-8";
export var labelContainer = "_so-6";
export var pending = "_so-3";